import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var FontLoader = /*#__PURE__*/function () {
  function FontLoader() {
    _classCallCheck(this, FontLoader);
  }

  _createClass(FontLoader, null, [{
    key: "loadFontSet",
    value: function loadFontSet(fontSet) {
      var sheet = window.document.styleSheets[0]; // eslint-disable-next-line array-callback-return

      Object.keys(fontSet).map(function (fontName) {
        var url = fontSet[fontName];
        var webUrl = url;

        if (url.startsWith('//')) {
          webUrl = url;
        } else if (url.startsWith('http://') || url.startsWith('https://')) {
          // eslint-disable-next-line prefer-destructuring
          webUrl = url.split(':')[1];
        }

        sheet.insertRule("@font-face { font-family: ".concat(fontName, ";src:url(").concat(webUrl, ") format('truetype');}"), sheet.cssRules.length); // const newStyle = document.createElement('style')
        // newStyle.appendChild(document.createTextNode(`@font-face { font-family: ${fontName};src:url(${webUrl}) format('truetype');}`))
        // document.head.appendChild(newStyle)
      });
    }
  }]);

  return FontLoader;
}();

export { FontLoader as default };